import React from 'react'

const t  = {
    FR: {
        'Welcome!': 'Bienvenue!',
        'This is a personal website.': 'Ceci est un site web personnel.',
        [`So I'm developing this site slowly, in my free time...`]: `Je développe donc ce site tranquillement, par temps libre...`,
        'Site objectives': <>
            <h3>Mes objectifs pour ce site:</h3>
            <p>
                Je désire ajouter des "petits helpers" utiles pour tout le monde, comme une <i>"liste de choses à faire"</i> et des outils de budget personnel. J'ai plein d'idées.
            </p>
            <p>
                Si vous aimez mes outils, vous pourrez éventuellement m'envoyer un petit don symbolique. Cette fonction n'existe pas encore, alors pour le moment c'est <b>gratuit</b> et ouvert à tous.
            </p>
            <p>
                Je ne collecte et ne collecterai jamais AUCUNE donnée à propos de vous... Même pas votre addresse courriel ou quoi que ce soit qui pourrait vous identifier. Voir les liens de bas de page pour plus de détail à ce niveau.
            </p>
        </>
    },
    EN: {
        'Welcome!': 'Welcome!',
        'This is a personal website.': 'This is a personal website.',
        [`So I'm developing this site slowly, in my free time...`]: `So I'm developing this site slowly, in my free time...`,
        'Site objectives': <>
            <h3>My goals for this site:</h3>
            <p>
                I want to add "little helpers" that are useful for everyone, like a <i>"todo list"</i> and personal budget tools. I have a lot of ideas.
            </p>
            <p>
                If you like my tools, you can possibly send me a small symbolic donation. This function does not exist yet, so for now it is <b>free</b> and open to all.
            </p>
            <p>
                I do not and will never collect ANY data about you... Not even your email address or anything that could identify you. See the links at the bottom of the page for more details on this.
            </p>
        </>
    },
    ES: {
        'Welcome!': '¡Bienvenido!',
        'This is a personal website.': 'Este es un sitio web personal.',
        [`So I'm developing this site slowly, in my free time...`]: `Así que estoy desarrollando este sitio tranquilamente, en mi tiempo libre...`,
        'Site objectives': <>
            <h3>Mis objetivos para este sitio:</h3>
            <p>
                Quiero agregar "pequeños ayudantes" que sean útiles para todos, como una <i>"lista de tareas pendientes"</i> y herramientas de presupuesto personal. Tengo muchas ideas.
            </p>
            <p>
                Si te gustan mis herramientas, posiblemente puedas enviarme una pequeña donación simbólica. Esta función aún no existe, por lo que por ahora es <b>gratuita</b> y abierta a todos.
            </p>
            <p>
                No recopilo ni recolectaré NINGÚN dato sobre usted... Ni siquiera su dirección de correo electrónico ni nada que pueda identificarlo. Consulte los enlaces en la parte inferior de la página para obtener más detalles sobre esto.
            </p>
        </>
    },
    PT: {
        'Welcome!': 'Bem-vindo(a)!',
        'This is a personal website.': 'Este é um site pessoal.',
        [`So I'm developing this site slowly, in my free time...`]: 'Estou desenvolvendo este site lentamente, no meu tempo livre...',
        'Site objectives': <>
            <h3>Meus objetivos para este site:</h3>
            <p>
                Quero adicionar “pequenos ajudantes” que sejam úteis para todos, como uma <i>“lista de tarefas”</i> e ferramentas de orçamento pessoal. Eu tenho muitas ideias.
            </p>
            <p>
                Se você gosta das minhas ferramentas, você pode me enviar uma pequena doação simbólica. Esta função ainda não existe, por enquanto é <b>gratuita</b> e aberta a todos.
            </p>
            <p>
                Eu não coleto e nunca irei coletar NENHUM dado sobre você... Nem mesmo seu endereço de e-mail ou qualquer coisa que possa identificá-lo. Veja os links na parte inferior da página para mais detalhes sobre isso.
            </p>
        </>
    },
}

export default t